import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.min.css';
import './custom2.css';
import { useNavigate } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';


export default function Header({logout}) {
  

	function readCurrentState(){
		if(window.location.pathname.indexOf("/dashboard")!=-1 || window.location.pathname=="/"){
			return "r";
		}else if(window.location.pathname.indexOf("/clusters")!=-1){
			return "cl";
		}else if(window.location.pathname.indexOf("/downloads")!=-1){
			return "dl";
		}else{
			return 'r';
		}
	}
	const [selected,setSelected] =useState(readCurrentState());
	const [logoff,setLogoff] =useState(false);
	

	var userInfo = localStorage.getItem("userInfo");
	if(userInfo){
	  userInfo = JSON.parse(userInfo);
	}





  return (
   <> <header className="Home_titleBar__3XDTs flex items-center justify-between " style={{zIndex:10000}}>
		<a href="/" className="px-10 flex">
			<span className="flex items-center"><img src="/1dride.png" className='h-10'/> </span>&nbsp;&nbsp;
		</a>
		
		{
			userInfo &&
		<a style={{"border":"1px solid white"}} className="rounded-lg Home_link__3O3ajgithub" href="#" onClick={(e)=>setLogoff(true)}
			rel="noopener noreferrer">
			<div>{userInfo.username+"@"+userInfo.partnerId}</div>
			
		</a>
		}
		
		
	</header>
	{ logoff && 
		<SweetAlert style={{color:"black"}}
	warning
	showCancel
	confirmBtnText="Yes, Proceed!"
	confirmBtnBsStyle="danger"
	title="Are you sure?"
	onConfirm={()=>{setLogoff(false);logout()}}
	onCancel={()=>{setLogoff(false)}}
	focusCancelBtn
  >
	
  </SweetAlert>

		}</>
	
  );
}

